import { useFadeUp } from '@/hooks/useFadeUp';
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const { ref, visible } = useFadeUp();

  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const serviceKeys = [
    "footer.service_0",
    "footer.service_1",
    "footer.service_2",
    "footer.service_3",
    "footer.service_4",
    "footer.service_5",
  ];

  return (
    <footer className="relative bg-background-100 pt-8 pb-24 sm:pb-16 md:pb-8 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-500/40 to-transparent"></div>
      <div ref={ref} className={`max-w-6xl mx-auto px-6 md:px-10 fade-up-hidden ${visible ? 'fade-up-visible' : ''}`}>
        <div className="flex flex-col lg:flex-row lg:justify-between gap-10 lg:gap-16">
          <div className="shrink-0">
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="inline-block cursor-pointer"
            >
              <img
                src="/img/logo-imagotipo.webp"
                alt="AIdeal Media"
                className="h-10 w-auto"
              />
            </a>
            <div className="mt-6 space-y-3.5 text-sm leading-relaxed max-w-sm" style={{ color: "#215E88" }}>
              <p>{t("footer.tagline")}</p>
              <p>{t("footer.description_line1")}<br />{t("footer.description_line2")}</p>
              <p>{t("footer.locations")}</p>
            </div>
          </div>

          <div className="shrink-0">
            <h4 className="font-heading text-sm font-bold tracking-wide uppercase" style={{ color: "#215E88" }}>
              {t("footer.col_services")}
            </h4>
            <ul className="mt-5 space-y-3">
              {serviceKeys.map((sk) => (
                <li key={sk}>
                  <a
                    href="#servicios"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo("#servicios");
                    }}
                    className="text-sm cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity"
                    style={{ color: "#215E88" }}
                  >
                    {t(sk)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="shrink-0">
            <h4 className="font-heading text-sm font-bold tracking-wide uppercase" style={{ color: "#215E88" }}>
              {t("footer.col_navigation")}
            </h4>
            <ul className="mt-5 space-y-3">
              {[
                { key: "footer.nav_why_ai", href: "#por-que-ia" },
                { key: "footer.nav_roi_impact", href: "#roi" },
                { key: "footer.nav_how_we_work", href: "#como-trabajamos" },
                { key: "footer.nav_faq", href: "#faq" },
                { key: "footer.nav_roi_roadmap", href: "#diagnostico" },
              ].map((l) => (
                <li key={l.key}>
                  <a
                    href={l.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(l.href);
                    }}
                    className="text-sm cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity"
                    style={{ color: "#215E88" }}
                  >
                    {t(l.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs" style={{ color: "#215E88" }}>
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-6">
            <a
              href="/privacidad"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs cursor-pointer hover:opacity-80 transition-opacity"
              style={{ color: "#215E88" }}
            >
              {t("footer.privacy")}
            </a>
            <a
              href="/terminos"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs cursor-pointer hover:opacity-80 transition-opacity"
              style={{ color: "#215E88" }}
            >
              {t("footer.terms")}
            </a>
            <a
              href="/cookies"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs cursor-pointer hover:opacity-80 transition-opacity"
              style={{ color: "#215E88" }}
            >
              {t("footer.cookies")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}